// PARENT INTERFACES
import { IAttendeeCategory } from "../dataProvider/interfaces/IEvent";

// INTERFACES
export interface IFieldsTemplate {
    [index: string]: string;
}

export interface IGetCustomFields {
    id: number;
    label: string;
    fieldName: string;
    visible: boolean;
    deleted: boolean;
    isApplied: boolean;
};

export interface IAddCategoryPayload extends IAttendeeCategory {
    type?: String;
    payload?: IAttendeeCategory;
};

export interface ICategoriesState {
    list: Array<IAttendeeCategory>;
    loading: Boolean;
    action?: IAddCategoryPayload;
    isApiCallDone?: Boolean,
    isAdding?: Boolean;
}

// attendee standard fields accepted by API
export const attendeeFieldsTemplate: IFieldsTemplate = {
    THIRD_PARTY_ID: "ThirdPartyID",
    CATEGORY: "Category",
    FIRST_NAME: "FirstName",
    LAST_NAME: "LastName",
    REGISTRATION_STATUS: "RegistrationStatus",
    BARCODE: "Barcode",
};

export const attendeeDefaultFields: Array<IGetCustomFields> = [
    { id: 1, fieldName: "email", label: "Email", deleted: false, isApplied: true, visible: true },
    { id: 2, fieldName: "company", label: "Company", deleted: false, isApplied: true, visible: true },
    { id: 3, fieldName: "jobtitle", label: "JobTitle", deleted: false, isApplied: true, visible: true },
    { id: 4, fieldName: "country", label: "Country", deleted: false, isApplied: true, visible: true }
];

export const attendeeAddonCustomFields: IFieldsTemplate = {
    EMAIL: "Email",
    COMPANY: "Company",
    JOB_TITLE: "JobTitle",
    COUNTRY: "Country"
};

// session standard fields accepted by API
export const sessionFieldsTemplate = {
    EXTERNAL_SESSION_ID: "ExternalSessionID",
    NAME: "Name",
    START: "StartDate",
    START_TIME: "StartTime",
    END: "EndDate",
    END_TIME: "EndTime",
    SESSION_LOCATION: "SessionLocation",
    RESTRICTED_SESSION: "IsRestricted",
    CHECK_CAPACITY_LIMIT: "CheckCapacityLimit",
    DEFAULT_ACCESS_AMOUNT: "DefaultSessionAccessAmount",
    CAPACITY_LIMIT: "Capacitylimit",
    ALLOW_OUT_SCANNING: "AllowOUT-scanning",
    ALLOW_CHECK_IN: "Allowforcecheck-in",
};

// reservation standard fields accepted by API
export const reservationFieldsTemplate = {
    ATTENDEE_THIRD_PARTY_ID: "AttendeeThirdPartyID",
    AMOUNT: "Amount",
    MESSAGE: "Message",
};

// LABELS
export const fieldLabels = {
    [sessionFieldsTemplate.EXTERNAL_SESSION_ID]: "External Session ID",
    [sessionFieldsTemplate.NAME]: "Name",
    [sessionFieldsTemplate.START]: "Start Date",
    [sessionFieldsTemplate.START_TIME]: "Start Time",
    [sessionFieldsTemplate.END]: "End Date",
    [sessionFieldsTemplate.END_TIME]: "End Time",
    [sessionFieldsTemplate.SESSION_LOCATION]: "Session Location",
    [sessionFieldsTemplate.RESTRICTED_SESSION]: "Restricted Session",
    [sessionFieldsTemplate.CHECK_CAPACITY_LIMIT]: "Limit Number Of Scans",
    [sessionFieldsTemplate.DEFAULT_ACCESS_AMOUNT]: "Number Of scans (If Limited)",
    [sessionFieldsTemplate.CAPACITY_LIMIT]: "Capacity limit",
    [sessionFieldsTemplate.ALLOW_OUT_SCANNING]: "Allow OUT-scanning",
    [sessionFieldsTemplate.ALLOW_CHECK_IN]: "Allow force check-in"
};

export const initCategoriesList: ICategoriesState = {
    isAdding: false,
    loading: true,
    isApiCallDone: false,
    list: []
};

// FUNCTIONS
export const getFieldLabel = (id: string): string => {
    if (fieldLabels[id]) return fieldLabels[id];
    return id;
};
